import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TermoAceiteComponent } from '../termo-aceite/termo-aceite.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, take, finalize } from 'rxjs';
import { UniqueIdService } from '../../services/unique-id/unique-id.service';
import { UserService } from '../../services/user/user.service';
import { LoadingService } from '../loading/loading.service';

import { ToastService } from '../../services/toast/toast.service';
import { cpfValidator } from '../../shared/validators/cpf-validator';
import { phoneNumberValidator } from '../../shared/validators/phone-validator';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-cadastro-pessoas',
  templateUrl: './cadastro-pessoas.component.html',
  styleUrls: ['./cadastro-pessoas.component.scss'],
})
export class CadastroPessoasComponent implements OnInit {
  hide = true;
  public id: string;
  subsctiptions: Subscription[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  form: FormGroup;
  isValidCPF: boolean = false;
  dialogOpen: boolean = false;
  token: string | null = null;
  termo: any;
  registerFinished: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private uniqueIdService: UniqueIdService,
    private fb: FormBuilder,
    private userService: UserService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.id = this.uniqueIdService.generateUniqueIdWithPrefix('cadastroPessoa');
    this.getTerm();
    this.form = this.fb.group({
      nome: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(200),
        ],
      ],
      cpf: ['', [Validators.required, cpfValidator()]],
      telefone: ['', [Validators.required, phoneNumberValidator()]],
      idTermo: [null],
      aceiteTermos: [false, Validators.required],
    });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token');

      const name = this.getNameFromToken(this.token);
      if (name) {
        this.form.patchValue({ nome: name });
      }
    });
  }

  private getNameFromToken(token: string | null): string | null {
    if (!token) return null;

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.nome || null;
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  onSubmit() {
    const form = this.form.value;
    form.cpf = form.cpf.replace(/\D/g, '');
    form.telefone = form.telefone.replace(/\D/g, '');

    this.loadingService.showLoading();
    this.userService
      .finalizeRegistration(form, this.token)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe(
        (response: any) => {
          this.toastService.showSuccess(response.message);
          this.registerFinished = true;
        },
        (erro) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
  }

  openDialog() {
    const dialogRef = this.dialog.open(TermoAceiteComponent, {
      data: { termo: this.termo.textoTermo },
    });
    this.dialogOpen = true;
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogOpen = false;
    });
  }

  getTerm() {
    this.userService
      .getTerm()
      .pipe(
        take(1),
        finalize(() => {})
      )
      .subscribe(
        (response) => {
          this.termo = response;
          this.form.patchValue({ idTermo: this.termo.idTermo });
        },
        (error) => {
          this.toastService.showError(error.error.message);
        }
      );
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
